import * as React from "react";
import * as ReactQuery from "react-query";
import * as uuid from "uuid";

import {
  BodyScrollControllerProvider,
  CustomerSessionProvider,
  JoinDrawerProvider,
  JoinFormProvider,
  LocalizationProvider,
  LoginFormProvider,
  OneTimePasswordProvider,
  PresenterForScrollProvider,
  ProminentErrorProvider,
} from "../Common";

import {
  PdpAnalyticsProvider,
  PdpLoginAppProvider,
  PdpLoginDrawerTriggersProvider,
  PdpWishlistProvider,
  ReactPdpFeaturesProvider,
  ReactPdpInitialStateProvider,
  usePdpAnalytics,
  useReactPdpInitialState,
} from "./providers";

import {
  Page,
  PDPInitialStateProps,
} from "./Page";

const queryClient = new ReactQuery.QueryClient();

interface AppProps {
  mountElement: Element;
}

export const App: React.FunctionComponent<AppProps> = (props) => {
  const bodyScrollControllerGuid = React.useMemo(() => {
    return uuid.v4();
  }, []);

  return (
    <BodyScrollControllerProvider guid={bodyScrollControllerGuid}>
      <ReactQuery.QueryClientProvider client={queryClient}>
        <ProminentErrorProvider>
          <PresenterForScrollProvider>
            <ReactPdpInitialStateProvider mountElement={props.mountElement}>
              <ReactPdpFeaturesProvider>
                <LocalizationProvider>
                  <PdpAnalyticsProvider>
                    <CustomerSessionProvider
                      useInitialState={useReactPdpInitialState}
                    >
                      <PdpLoginAppProvider>
                        <LoginFormProvider
                          useInitialState={useReactPdpInitialState}
                        >
                          <JoinFormProvider
                            useInitialState={useReactPdpInitialState}
                          >
                            <OneTimePasswordProvider
                              useInitialState={useReactPdpInitialState}
                              useAnalytics={usePdpAnalytics}
                            >
                              <JoinDrawerProvider>
                                <PdpLoginDrawerTriggersProvider>
                                  <PdpWishlistProvider>
                                    <Page
                                      useInitialState={
                                        useReactPdpInitialState as unknown as () => {
                                          initialState: PDPInitialStateProps;
                                        }
                                      }
                                    />
                                  </PdpWishlistProvider>
                                </PdpLoginDrawerTriggersProvider>
                              </JoinDrawerProvider>
                            </OneTimePasswordProvider>
                          </JoinFormProvider>
                        </LoginFormProvider>
                      </PdpLoginAppProvider>
                    </CustomerSessionProvider>
                  </PdpAnalyticsProvider>
                </LocalizationProvider>
              </ReactPdpFeaturesProvider>
            </ReactPdpInitialStateProvider>
          </PresenterForScrollProvider>
        </ProminentErrorProvider>
      </ReactQuery.QueryClientProvider>
    </BodyScrollControllerProvider>
  );
};
